import { TagTypes } from "../../../Api/Types/tagTypes";
import { PagedList } from "../../Shared/Types/common";
import {
	Category,
	CategoryListRequest,
	CategoryWithImages,
} from "../Types/category.types";
import { categoriesApi } from "./categoriesApi";

const extendedCategoriesApi = categoriesApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategoriesList: builder.query<PagedList<Category>, CategoryListRequest>({
      query: (param) => ({
        url: '/categories/list',
        params: param,
      }),
      providesTags: [{ type: TagTypes.Category, id: TagTypes.List }],
    }),
    getCategoryWithImages: builder.query<CategoryWithImages, number>({
      query: (id) => `/categories/${id}/with-images`,
      providesTags: (result, error, id) => [{ type: TagTypes.CategoryImages, id }],
    }),
    // NEW: Upload images using new backend API
    uploadCategoryImages: builder.mutation<
      { imageIds: string[]; count: number },
      { categoryId: number; files: File[] }
    >({
      query: ({ categoryId, files }) => {
        const formData = new FormData();
        files.forEach((file) => formData.append('Files', file)); // Backend expects "Files" (capital F)
        formData.append('Category', 'Category'); // Backend expects "Category"
        formData.append('EntityId', categoryId.toString()); // Backend expects "EntityId"

        return {
          url: '/images/upload-multiple',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error, { categoryId }) => [
        { type: TagTypes.CategoryImages, id: categoryId },
      ],
    }),
    // NEW: Delete image by ID (not path)
    deleteCategoryImage: builder.mutation<void, { imageId: string; categoryId: number }>({
      query: ({ imageId }) => {
        console.log('[deleteCategoryImage] Deleting:', { imageId, url: `/images/${imageId}` });

        return {
          url: `/images/${imageId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, { categoryId }) => [
        { type: TagTypes.CategoryImages, id: categoryId },
      ],
    }),
  }),
  overrideExisting: false,
});
export const {
	useGetCategoriesListQuery,
	useDeleteCategoryImageMutation,
	useUploadCategoryImagesMutation,
	useGetCategoryWithImagesQuery,
} = extendedCategoriesApi;
